
import { useLanguage } from '@/contexts/LanguageContext';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { useAmplitudeEvents } from '@/utils/amplitudeEvents';

const FaqSection = () => {
  const { t } = useLanguage();
  const { trackFAQsClicked } = useAmplitudeEvents();
  
  const faqs = [
    {
      id: 1,
      question: t('faq.question_one'),
      answer: t('faq.answer_one')
    },
    {
      id: 2,
      question: t('faq.question_two'),
      answer: t('faq.answer_two')
    },
    {
      id: 3,
      question: t('faq.question_three'),
      answer: t('faq.answer_three')
    },
    {
      id: 4,
      question: t('faq.question_four'),
      answer: t('faq.answer_four')
    },
    {
      id: 5,
      question: t('faq.question_five'),
      answer: t('faq.answer_five')
    },
    {
      id: 6,
      question: t('faq.question_six'),
      answer: t('faq.answer_six')
    },
    {
      id: 7,
      question: t('faq.question_seven'),
      answer: t('faq.answer_seven')
    }
  ];

  const handleFAQClick = (question: string) => {
    trackFAQsClicked(question);
  };

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            {t('faq.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {t('faq.subtitle')}
          </p>
        </div>
        
        <div className="max-w-4xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map(faq => (
              <AccordionItem key={faq.id} value={`item-${faq.id}`} className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden">
                <AccordionTrigger 
                  className="px-6 py-4 text-left text-base md:text-lg font-semibold text-gray-900 hover:bg-gray-50 hover:no-underline"
                  onClick={() => handleFAQClick(faq.question)}
                >
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-4 text-gray-700 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
